import { render, staticRenderFns } from "./TeacherSave.vue?vue&type=template&id=505e50b9&"
import script from "./TeacherSave.vue?vue&type=script&lang=js&"
export * from "./TeacherSave.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSave.vue?vue&type=style&index=0&id=505e50b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports